<div class="wrapper container mx-auto">
  <ng-content></ng-content>
</div>
